import type { Localized } from './types';
import { formatDate } from './utils';

export const JOB_TYPES: { value: string; label: Localized }[] = [
  { value: 'full_time', label: { en: 'Full-time', te: 'పూర్తి సమయం' } },
  { value: 'part_time', label: { en: 'Part-time', te: 'పార్ట్ టైమ్' } },
  { value: 'contract', label: { en: 'Contract', te: 'కాంట్రాక్ట్' } },
  { value: 'internship', label: { en: 'Internship', te: 'ఇంటర్న్‌షిప్' } },
  { value: 'temporary', label: { en: 'Temporary', te: 'తాత్కాలికం' } },
  { value: 'daily_wage', label: { en: 'Daily wage', te: 'రోజు కూలీ' } },
  { value: 'work_from_home', label: { en: 'Work from home', te: 'ఇంటి నుండి పని' } },
];

export const SALARY_PERIODS: { value: string; label: Localized }[] = [
  { value: 'month', label: { en: 'per month', te: 'నెలకు' } },
  { value: 'day', label: { en: 'per day', te: 'రోజుకు' } },
  { value: 'hour', label: { en: 'per hour', te: 'గంటకు' } },
  { value: 'year', label: { en: 'per year', te: 'సంవత్సరానికి' } },
];

export const jobTypeLabel = (v: string | undefined, lang: 'en' | 'te') => {
  const l = JOB_TYPES.find((t) => t.value === v)?.label;
  return l ? l[lang] || l.en : undefined;
};

const inr = (n: number) => `₹${n.toLocaleString('en-IN')}`;

/** "₹12,000 – ₹15,000 per month", "From ₹500 per day", or undefined when no salary is given. */
export function salaryText(s: { min?: number | null; max?: number | null; period?: string } | undefined, lang: 'en' | 'te') {
  if (!s || (s.min == null && s.max == null)) return undefined;
  const period = SALARY_PERIODS.find((p) => p.value === (s.period ?? 'month'))?.label;
  const per = period ? ` ${period[lang] || period.en}` : '';
  if (s.min != null && s.max != null) return s.min === s.max ? `${inr(s.min)}${per}` : `${inr(s.min)} – ${inr(s.max)}${per}`;
  if (s.min != null) return `${lang === 'te' ? 'కనీసం' : 'From'} ${inr(s.min)}${per}`;
  return `${lang === 'te' ? 'గరిష్టం' : 'Up to'} ${inr(s.max!)}${per}`;
}

/** "Apply by 12 Nov" / "Closes today" / "Applications closed". */
export function closesText(closesAt: string | undefined, closed: boolean | undefined, lang: 'en' | 'te') {
  if (closed) return lang === 'te' ? 'దరఖాస్తులు ముగిశాయి' : 'Applications closed';
  if (!closesAt) return undefined;
  const days = Math.floor((new Date(closesAt).getTime() - Date.now()) / 864e5);
  if (days < 1) return lang === 'te' ? 'ఈరోజే చివరి రోజు' : 'Closes today';
  return `${lang === 'te' ? 'చివరి తేదీ' : 'Apply by'} ${formatDate(closesAt, lang, { day: 'numeric', month: 'short' })}`;
}
